import { api, tokenStore } from './client'

export type User = {
  id: number
  email: string
  name: string
  role: 'owner' | 'admin' | 'member' | 'viewer'
  avatar_color?: string | null
  timezone: string
  date_format: string
}

export type ApiToken = {
  id: number
  name: string | null
  token_prefix: string
  scopes: string[] | null
  last_used_at: string | null
  expires_at: string | null
  created_at: string
}

export type LoginResponse = {
  token: string
  token_type: 'Bearer'
  expires_at: string | null
  user: User
}

export type MeResponse = {
  user: User
  token: ApiToken
}

export async function login(email: string, password: string, deviceName?: string): Promise<LoginResponse> {
  const res = await api<LoginResponse>('/auth/login', {
    method: 'POST',
    body: { email, password, device_name: deviceName ?? 'Web' },
    anonymous: true,
  })
  tokenStore.set(res.token)
  return res
}

export async function me(): Promise<MeResponse> {
  return api<MeResponse>('/auth/me')
}

export async function logout(): Promise<void> {
  try {
    await api<unknown>('/auth/logout', { method: 'POST' })
  } finally {
    tokenStore.clear()
  }
}

export async function listTokens(): Promise<ApiToken[]> {
  return api<ApiToken[]>('/auth/tokens')
}

export async function ping(): Promise<{ pong: boolean; time: string }> {
  return api<{ pong: boolean; time: string }>('/ping')
}
